module.exports = __webpack_public_path__ + "static/media/arrow.d1145039.svg";